import { TDeepPartial } from "@/types/utils";

type TUnknownRecord = Record<string, unknown>;

const isMergeable = (value: unknown): value is TUnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const mergeRecords = (
  base: TUnknownRecord,
  override: TUnknownRecord,
): TUnknownRecord => {
  const merged: TUnknownRecord = { ...base };

  for (const [key, value] of Object.entries(override)) {
    if (value === undefined) continue;

    const current = merged[key];

    // Nested sections merge key by key; leaves and arrays replace outright.
    merged[key] =
      isMergeable(current) && isMergeable(value)
        ? mergeRecords(current, value)
        : value;
  }

  return merged;
};

export const mergeContentOverride = <TContent>(
  base: TContent,
  override?: TDeepPartial<TContent>,
): TContent => {
  if (!override) return base;
  if (!(isMergeable(base) && isMergeable(override))) return base;

  return mergeRecords(base, override) as TContent;
};
